<template>
  <portal-context-required-template>
    <page-title />
    <cloud-cannon-content
      class="_p0 _ptxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header"
    />
   <billing-balances v-if="paymentHistoryEnabled" @download-clicked="exportToCSV"/>
    <invoices-view-by-context />
    <cloud-cannon-content
      class="_p0 _ptxs _pbxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.footer"
    />
  </portal-context-required-template>
</template>

<script>
  import PageTitle from './BillingOverview/PageTitle';
  import BillingBalances from './BillingOverview/BillingBalances';
  import InvoicesViewByContext from './BillingOverview/InvoicesViewByContext';
  import fetchable from '@mixins/fetchable';
  import { useBilling } from '@composables/useBilling';
  import CloudCannonable from '@mixins/CloudCannonable';
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { useStore } from '@vue3shims';
  import { onBeforeMount, ref, watch } from '@vue/composition-api';
  import { useFormattable } from '@composables/useFormattable';

  export default {
    setup() {
      const { hasSelection, selected } = useGroupSelector();
      const store = useStore();
      const { invoicePaymentHistory, paymentHistoryEnabled } = useBilling();
      const exporting = ref(false);
      const { now } = useFormattable();

      const exportToCSV = () => {
        console.log('helllooooooo!');
        exporting.value = true;
        let csvContent = [];
        let csvHelpers = [
          { text: 'Payment Date', value: 'paidDate' },
          { text: 'Invoice Type', value: 'invoiceTypeDescription' },
          { text: 'Group', value: 'group', visible: true },
          { text: 'Subgroup', value: 'subGroup', visible: true },
          { text: 'Invoice Date', value: 'displayInvoiceDate' },
          { text: 'Invoice No.', value: 'invoiceNumber' },
          { text: 'Invoice Amount', value: 'displayInvoiceAmount' },
          { text: 'Payment Type', value: 'paymentTypeDescription' },
          { text: 'Payment Method', value: 'paymentMethod' },
          { text: 'Payment Cycle', value: 'paymentCycleDescription' },
          { text: 'Transaction Amount', value: 'displayPaidAmount' },
          { text: 'Paid Amount', value: 'displayPaidAmount' },
          { text: 'Open Amount', value: 'displayOpenAmount' },
          { text: 'Adjustments', value: 'displayAdjustments' },
          { text: 'User Id', value: 'paidUser' },
          { text: 'Invoice Status', value: 'paymentStatus' },
          { text: 'Payment Decision', value: 'paymentDecision' },
          { text: 'Failure Reason', value: 'authReasonCode' }
        ];

        let firstRow = csvHelpers.map(helper => helper.text)
        csvContent.push(firstRow)

        invoicePaymentHistory.value
          .sort((a, b) => {
            return new Date(b.paidDate) - new Date(a.paidDate)
          })
          .map(paymentHistory => {
            return csvHelpers.map(helper => `\"${paymentHistory[helper.value] ? paymentHistory[helper.value] : ''}\"`)
          })
          .forEach(row => csvContent.push(row))

        let csvString = csvContent
          .map(line => line.join(','))
          .join('\r\n')

        const now = new Date()
        const month = ("0" + (now.getMonth() + 1)).slice(-2); //Get month (01-12)
        const day = ("0" + now.getDate()).slice(-2); //Get day (01-31)
        //const year = now.getFullYear().toString().slice(-2); //Get last 2 digits of the year
        const year = now.getFullYear().toString();
        const hours = ("0" + now.getHours()).slice(-2); //Get hour (00-23)
        const minutes = ("0" + now.getMinutes()).slice(-2); //Get hour (00-23)
        const seconds = ("0" + now.getSeconds()).slice(-2); //Get hour (00-23)

        //const formattedDate = `${month}${day}${year}${hours}${minutes}${seconds}`
        const formattedDate = `${year}-${month}-${day}`

        let a = document.createElement('a')
        let csvData = new Blob([csvString], { encoding: 'UTF-8', type: 'text/csv;charset=UTF-8' })
        a.href = URL.createObjectURL(csvData)
        console.log("name of the file " + `eyemed_payment_history_${formattedDate}.csv`)
        a.download = `eyemed_payment_history_${formattedDate}.csv`
        document.body.appendChild(a)
        a.click()

        exporting.value = false;
      }

      const fetchData = () => {
        store.dispatch('GET_PAYMENT_LOBS');
        if(hasSelection.value) {
          store.dispatch('GET_INVOICES', { params: { status: 'ALL' }});
          store.dispatch('GET_INVOICE_PAYMENT_HISTORY');
        }
      }
      onBeforeMount(() => {
        fetchData();
      });

      watch(selected, () => {
        fetchData();
      });

      return {
        exportToCSV,
        hasSelection,
        paymentHistoryEnabled,
      }  
    },
    mixins: [
      fetchable,
      CloudCannonable
    ],
    components: {
      PageTitle,
      BillingBalances,
      InvoicesViewByContext
    },
    computed: {
      // ...mapGetters('portalContext', [ 'portalContextSelected' ]),
      fetchers () {
        return [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/billing.json'
            },
            config: {
              root: true
            }
          },
          // {
          //   action: 'GET_PAYMENT_LOBS'
          // },
          // {
          //   action: 'GET_INVOICES',
          //   options: {
          //     params: {
          //       status: 'ALL'
          //     }
          //   },
          //   shouldFetch: this.hasSelection,
          // }
        ]
      }
    }
  }
</script>
